// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"88d2da29","27":"83076197","180":"db12e7d2","248":"14aba9d8","334":"6e240d9a","514":"3649a871","787":"b71e2d9e","865":"94bec3b7","900":"fe1ea0bc","951":"051ed497"}[chunkId] + ".chunk.js";
};